import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=bc305fde"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports